import { WSAlert } from "@wingspanhq/fe-component-library";
import { useHistory } from "react-router-dom";
import {
  useAccount,
  useQueryAccountMissingFields
} from "../../../query/users/queries";
import { PATH_SETTINGS_ACCOUNT_INFO } from "../paths";
import { useDefaultPayoutMethod } from "./payout/DefaultPayoutMethod";

export const usePayoutMethodMissingData = () => {
  const defaultPayoutMethod = useDefaultPayoutMethod();
  const queryAccount = useAccount(defaultPayoutMethod?.id!, {
    enabled:
      defaultPayoutMethod?.type === "Account" && !!defaultPayoutMethod?.id
  });
  const queryAccountMissingFields = useQueryAccountMissingFields(
    defaultPayoutMethod?.id!,
    {
      enabled:
        !!queryAccount.data?.country && queryAccount.data?.country !== "US"
    }
  );

  return queryAccountMissingFields.data;
};

export const AlertPayoutMethodMissingData: React.FC = () => {
  const history = useHistory();
  const payoutMethodMissingData = usePayoutMethodMissingData();

  if (
    (payoutMethodMissingData?.missingProfileFields || []).length === 0 &&
    (payoutMethodMissingData?.missingAddressFields || []).length === 0
  ) {
    return null;
  }

  return (
    <WSAlert
      theme="warning"
      icon="alert"
      title="Missing information required"
      action={{
        text: "Go to account settings",
        onClick: () => {
          history.push(PATH_SETTINGS_ACCOUNT_INFO);
        }
      }}
    >
      Additional information is required to complete your profile. Go to your
      account settings and provide the missing information to prevent payout
      delays.
    </WSAlert>
  );
};
